import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useBoundingClient } from '../../common/utils/hooks';
import { getLastLoginType } from '../../common/utils/storage';
import { Container } from './components/styled';
import { Footer } from './components/Footer';
import { LoginRandomImage } from '../../common/components/LoginRandomImage';
import { LoginProvider } from '../../common/providers_services/LoginProvider';
import { LoginForm } from './components/LoginForm';
import { SocialLoginForm } from './components/SocialLoginForm';
import { useLoginController } from '../../common/utils/useLoginController';
import { FlexRow } from '../../shared/FlexRow';
import { useLocation } from 'react-router-dom';
import { EditPassword } from './components/EditPassword';
import { ResetPassword } from './ResetPassword';

export const Login: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { client: formClient } = useBoundingClient(formRef);
  const { pathname } = useLocation();

  const [lastLoginClient, setLastLoginClient] = useState<DOMRect>();
  useEffect(() => {
    const lastLogin = getLastLoginType();
    if (!lastLogin) return;

    let button: HTMLElement | null = null;
    switch (lastLogin) {
      case 'google':
        button = document.getElementById('google-login');
        break;
      case 'kakao':
        button = document.getElementById('kakao-login');
        break;
      case 'naver':
        button = document.getElementById('naverIdLogin');
        break;
    }
    if (button) setLastLoginClient(button.getBoundingClientRect());
  }, []);

  const ctrl = useLoginController({ formRef });

  return (
    <GoogleOAuthProvider clientId={'516661429564-bent9j4fqnrae72qjncpu4v0s77ck4r5.apps.googleusercontent.com'}>
      <Wrapper>
        <Container form={formClient}>
          <FlexRow width={'100%'} justify={'flex-start'} style={{ padding: '3.2rem' }}>
            <button
              style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
              onClick={() => (window.location.href = '/')}
            >
              <img alt={'logo'} src={'/images/common/logo.svg'} />
            </button>
          </FlexRow>
          <div style={{ width: '100%', flex: '1' }}>
            {pathname.includes('edit-password') ? (
              <EditPassword />
            ) : pathname.includes('reset-password') ? (
              <ResetPassword />
            ) : (
              <LoginProvider value={ctrl}>{!ctrl.social ? <LoginForm /> : <SocialLoginForm />}</LoginProvider>
            )}
          </div>
          <Footer />

          {!pathname.includes('password') && lastLoginClient && (
            <TooltipWrapper client={lastLoginClient}>
              <Tooltip />
            </TooltipWrapper>
          )}
        </Container>

        <LoginRandomImage />
      </Wrapper>
    </GoogleOAuthProvider>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  > div {
    flex: 1;
    min-width: 0;
  }
`;

const TooltipWrapper = styled.div<{ client: DOMRect }>`
  position: absolute;
  left: ${p => p.client.left + p.client.width / 2}px;
  top: ${p => p.client.bottom + 13}px;
  transform: translateX(-50%);
  z-index: 1000;
`;
const Tooltip = styled.div`
  padding: 0.6rem 0.8rem;
  background-color: rgba(27, 29, 31, 0.9);
  font-size: 1.4rem;
  color: white;
  position: relative;

  &:before {
    content: '최근에 로그인 했어요';
    display: block;
  }

  &:after {
    content: '';
    width: 9px;
    height: 9px;
    display: block;
    rotate: 45deg;
    left: 50%;
    top: 0;
    position: absolute;
    background-color: inherit;
    transform: translateX(-50%);
  }
`;
